import { useQueryClient, useMutation } from '@tanstack/react-query';
import { closeTicket } from "../../api/TICKET/ticket";

export const useCloseTicket = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: ({ id, facturationModeId }) => closeTicket(id, facturationModeId),
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries({ queryKey: ['tickets'] });
        queryClient.invalidateQueries({ queryKey: ['inactiveTickets'] });
        queryClient.invalidateQueries({ queryKey: ["ticket", id] });
        queryClient.invalidateQueries({ queryKey: ['ticketsClient'] });
      },
    });
  };